<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
    <div style="display: flex; align-items: center;">
        <p class="modal-title">Historial de actividad de operarios</p>
    </div>
</div>

<div #modalContent class="w-full h-full p-0 m-0">
    @if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
        @if (usersActivityHistory && usersActivityHistory.length > 0) {
        <nz-table #basicTable [nzData]="usersActivityHistoryFiltered" class="m-0 p-0" nzSize="small" [nzLoading]="isLoading"
            nzTableLayout="auto" [nzBordered]="true" [nzFrontPagination]="false" [nzShowPagination]="false"
            [nzScroll]="{ y: (tableHeight || 0) + 'px' }">
            <thead>
                <tr>
                    <th>Trabajador</th>
                    <th>Rol</th>
                    <th>Nº pausas realizadas</th>
                    <th>Nº pausas reanudadas</th>
                    <th>Nº mermas realizadas</th>
                </tr>
            </thead>
            <tbody>
                @for (userActivityHistory of basicTable.data; track data) {
                <tr>
                    <td>{{ userActivityHistory.user.name }}</td>
                    <td>{{ userActivityHistory.user.profile?.name }}</td>
                    <td>{{ userActivityHistory.totalPausesStarted}}</td>
                    <td>{{ userActivityHistory.totalPausesFinished}}</td>
                    <td>{{ userActivityHistory.totalLosses}}</td>
                </tr>
                }
            </tbody>
        </nz-table>
        }
        @else {
        <div class="w-full h-full content-center">
            <nz-empty></nz-empty>
        </div>
        }
    }
</div>

<div *nzModalFooter>
    <div class="flex justify-end">
        <button (click)="handleCancel()" class="button secondary-button">
            Cerrar
        </button>
    </div>
</div>
